// extracted by mini-css-extract-plugin
module.exports = {"fashion_box":"fashion_box-1FLdHBNm"};